/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type GetBadgeBackupQueryVariables = Types.Exact<{
  userId: Types.Scalars["Int"];
}>;

export type GetBadgeBackupQuery = {
  claims: Array<
    Pick<Types.Claim, "id" | "user_id"> & {
      fields_HACKTHENORTH2026_APPLICATIONS: {
        answers: {
          badge_data_json: Pick<
            Types.StringFieldAnswerTypeWrapper,
            "value" | "updated_at"
          >;
        };
      };
    }
  >;
};

export const GetBadgeBackupDocument = gql`
  query GetBadgeBackup($userId: Int!) {
    claims(
      take: 1
      where: {
        pipeline: { is: { slug: { equals: "hackthenorth2026-applications" } } }
        user_id: { equals: $userId }
      }
    ) {
      id
      user_id
      fields_HACKTHENORTH2026_APPLICATIONS {
        answers {
          badge_data_json {
            value
            updated_at
          }
        }
      }
    }
  }
`;

/**
 * __useGetBadgeBackupQuery__
 *
 * To run a query within a React component, call `useGetBadgeBackupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBadgeBackupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBadgeBackupQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetBadgeBackupQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetBadgeBackupQuery,
    GetBadgeBackupQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetBadgeBackupQuery,
    GetBadgeBackupQueryVariables
  >(GetBadgeBackupDocument, baseOptions);
}
export function useGetBadgeBackupLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetBadgeBackupQuery,
    GetBadgeBackupQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetBadgeBackupQuery,
    GetBadgeBackupQueryVariables
  >(GetBadgeBackupDocument, baseOptions);
}
export type GetBadgeBackupQueryHookResult = ReturnType<
  typeof useGetBadgeBackupQuery
>;
export type GetBadgeBackupLazyQueryHookResult = ReturnType<
  typeof useGetBadgeBackupLazyQuery
>;
export type GetBadgeBackupQueryResult = ApolloReactCommon.QueryResult<
  GetBadgeBackupQuery,
  GetBadgeBackupQueryVariables
>;
